export const StatsCard = ({ title, value, icon, color = "blue", trend }) => {
    const colorClasses = {
        blue: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
        green: 'bg-green-500/10 text-green-500 border-green-500/20',
        amber: 'bg-amber-500/10 text-amber-500 border-amber-500/20',
        purple: 'bg-purple-500/10 text-purple-500 border-purple-500/20',
        pink: 'bg-pink-500/10 text-pink-500 border-pink-500/20'
    };

    return (
        <div className={`${colorClasses[color]} p-2 rounded-lg border backdrop-blur-sm`}>
            <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-slate-400 uppercase tracking-tight">{title}</span>
                {icon && <span className="text-sm">{icon}</span>}
            </div>
            <div className="text-lg font-bold text-white">{value}</div>
            {trend && (
                <div className="text-xs text-slate-400 mt-0.5">
                    {trend}
                </div>
            )}
        </div>
    );
};
